import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

export default function NotFound() {
    const navigate = useNavigate();

    useEffect(() => {
        // Redirect to home after 2 seconds
        const timer = setTimeout(() => {
            navigate('/', { replace: true });
        }, 2000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            backgroundColor: '#f5f5f5',
            padding: '20px',
            textAlign: 'center'
        }}>
            <div style={{
                backgroundColor: 'white',
                borderRadius: '8px',
                padding: '40px',
                maxWidth: '500px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
            }}>
                <div style={{
                    fontSize: '72px',
                    marginBottom: '20px'
                }}>
                    🔍
                </div>
                <h1 style={{
                    fontSize: '32px',
                    marginBottom: '15px',
                    color: '#333'
                }}>
                    404 - Page Not Found
                </h1>
                <p style={{
                    fontSize: '16px',
                    color: '#666',
                    marginBottom: '20px'
                }}>
                    The page you're looking for doesn't exist.
                </p>
                <p style={{
                    fontSize: '14px',
                    color: '#999'
                }}>
                    Redirecting to home page...
                </p>
                <div style={{
                    marginTop: '30px'
                }}>
                    <div className="spinner"></div>
                </div>
            </div>
        </div>
    );
}
